/**
 * Deadline timeout
 * @param {number} ms Milliseconds
 * @param {Promise} promise
 * @returns {Promise}
 */
function deadline(ms, promise) {
    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            reject(new Error("Promise timeout"));
        }, ms);

        promise.then(
            (res) => {
                clearTimeout(timeoutId);
                resolve(res);
            },
            (err) => {
                clearTimeout(timeoutId);
                reject(err);
            }
        );
    });
}

export default deadline;
